import { CreateLocationDto, Location } from 'src/api/generated'
import { ENDPOINTS_TAGS, rootApi } from 'src/v2/store/api/rootApi'

import {
  ILocationsFilter,
  LocationResponseModel,
  UpdateLocationRequest,
} from '../location.types'

export const locationsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocations: builder.query<LocationResponseModel, ILocationsFilter>({
      query: (queryArgs) => {
        return {
          url: '/v1/location',
          method: 'GET',
          params: {
            clinicId: queryArgs.clinicId,
            program: queryArgs.program,
            zipCode: queryArgs.zipCode,
            offset: queryArgs.offset,
            search: queryArgs.search,
          },
        }
      },
      providesTags: (result) =>
        result?.records.length
          ? [
              ...result.records.map(({ id }) => ({
                type: ENDPOINTS_TAGS.LOCATIONS,
                id,
              })),
              ENDPOINTS_TAGS.LOCATIONS,
            ]
          : [ENDPOINTS_TAGS.LOCATIONS],
    }),
    createLocation: builder.mutation<Pick<Location, 'id'>, CreateLocationDto>({
      query: (data) => {
        return {
          url: `/v1/location/`,
          method: 'POST',
          data: {
            ...data,
          },
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.LOCATIONS, ENDPOINTS_TAGS.GET_CLINIC],
    }),
    updateLocation: builder.mutation<
      Pick<Location, 'id'>,
      UpdateLocationRequest
    >({
      query: (data) => {
        const locationId = data.id
        const newValues = {
          name: data.name,
          email: data.email,
          businessDays: data.businessDays,
          phoneNumber: data.phoneNumber,
          languages: data.languages,
          address: data.address,
          clinicId: data.clinicId,
        }
        return {
          url: `/v1/location/${locationId}`,
          method: 'PATCH',
          data: {
            ...newValues,
          },
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.LOCATIONS, ENDPOINTS_TAGS.GET_CLINIC],
    }),
    deleteLocation: builder.mutation<{}, Location['id']>({
      query: (id) => {
        return {
          url: `/v1/location/${id}`,
          method: 'DELETE',
        }
      },
      invalidatesTags: [ENDPOINTS_TAGS.LOCATIONS, ENDPOINTS_TAGS.GET_CLINIC],
    }),
  }),
})

export const {
  useGetLocationsQuery,
  useCreateLocationMutation,
  useDeleteLocationMutation,
  useUpdateLocationMutation,
} = locationsApi
